(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["home-guides"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('home-guides-video')) {
    customElements.define('home-guides-video', class extends HTMLElement {
      connectedCallback() {
        this.video = this.querySelector('video');
        this.button = this.querySelector('button');
        this.section = this.closest('.home-guides');
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.userPaused = this.motion.matches;
        this.frame = 0;
        this.visible = false;
        this.events = new AbortController();
        const options = { signal: this.events.signal };
        this.queue = () => {
          if (!this.visible || this.frame) return;
          this.frame = requestAnimationFrame(() => {
            this.frame = 0;
            const rect = this.section.getBoundingClientRect();
            const height = Math.max(innerHeight, rect.height);
            const offset = this.motion.matches ? 0 : -rect.top;
            this.style.setProperty('--home-guides-video-height', `${height.toFixed(2)}px`);
            this.style.setProperty('--home-guides-video-y', `${offset.toFixed(2)}px`);
          });
        };
        this.updateButton = () => {
          const playing = !this.video.paused;
          this.button.classList.toggle('is-playing', playing);
          this.button.setAttribute('aria-label', playing ? this.button.dataset.pauseLabel : this.button.dataset.playLabel);
        };
        this.syncPlayback = () => {
          if (!this.visible || document.hidden || this.userPaused) {
            this.video.pause();
          } else {
            if (!this.video.getAttribute('src')) this.video.src = this.video.dataset.src;
            this.video.play().catch(this.updateButton);
          }
          this.queue();
        };
        this.button.addEventListener('click', () => {
          this.userPaused = !this.video.paused;
          this.syncPlayback();
        }, options);
        this.video.addEventListener('play', this.updateButton, options);
        this.video.addEventListener('pause', this.updateButton, options);
        this.motion.addEventListener('change', () => {
          this.userPaused = this.motion.matches;
          this.syncPlayback();
        }, options);
        document.addEventListener('visibilitychange', this.syncPlayback, options);
        window.addEventListener('scroll', this.queue, { ...options, passive: true });
        window.addEventListener('resize', this.queue, options);
        this.observer = new IntersectionObserver(entries => {
          this.visible = entries[0].isIntersecting;
          this.syncPlayback();
        }, { rootMargin: '100px 0px' });
        this.observer.observe(this.section);
        this.button.hidden = false;
        this.updateButton();
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        this.events?.abort();
        cancelAnimationFrame(this.frame);
        this.video?.pause();
      }
    });
  }

  if (!customElements.get('home-guides-fitment')) {
    customElements.define('home-guides-fitment', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized) return;
        const source = this.querySelector('[data-fitment-pool]');
        const cards = this.querySelectorAll('[data-fitment-card]');
        if (!source || !cards.length) return;
        const articles = [...new Map(JSON.parse(source.textContent).map(article => [article.url, article])).values()];
        for (let i = articles.length - 1; i > 0; i--) {
          const j = Math.floor(Math.random() * (i + 1));
          [articles[i], articles[j]] = [articles[j], articles[i]];
        }
        cards.forEach((card, index) => {
          const article = articles[index];
          if (!article) return;
          card.setAttribute('href', article.url);
          card.querySelector('.home-guides__title').textContent = article.title;
        });
        this.dataset.initialized = 'true';
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
